import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProfileEffects } from './+state/profile.effects';
import * as fromProfile from './+state/profile.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromProfile.PROFILE_FEATURE_KEY, fromProfile.reducer),
    EffectsModule.forFeature([ProfileEffects]),
  ],
})
export class OnmatStoreProfileModule {}
